module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img-2.61e3c202.webp";